import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-global-help-dialog',
  templateUrl: './global-help-dialog.component.html',
  styleUrls: ['./global-help-dialog.component.scss']
})
export class GlobalHelpDialogComponent implements OnInit{
  domainUrl: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GlobalHelpDialogComponent>) {}
  
  ngOnInit() {
    this.domainUrl = window.location.origin;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/global-help-dialog/global-help-dialog.component.ts